module.exports = __webpack_public_path__ + "img/1583890548.fd29dacb.jpg";